import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const Dashboard = ({ user, onEditProfile, onUserUpdate }) => {
  const [currentUser, setCurrentUser] = useState(user);

  const fetchLatestUserData = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCurrentUser(response.data);
      // Update parent component's user state
      if (onUserUpdate) {
        onUserUpdate(response.data);
      }
    } catch (error) {
      console.error('Error fetching latest user data:', error);
      // Fallback to prop data if API call fails
      setCurrentUser(user);
    }
  };

  // Fetch latest user data when component mounts
  useEffect(() => {
    fetchLatestUserData();
  }, []); // Only run on mount

  // Update local state when user prop changes
  useEffect(() => {
    setCurrentUser(user);
  }, [user]);

  // Listen for custom events to refresh data when profile is updated
  useEffect(() => {
    const handleProfileUpdate = () => {
      fetchLatestUserData();
    };

    window.addEventListener('profileUpdated', handleProfileUpdate);
    return () => window.removeEventListener('profileUpdated', handleProfileUpdate);
  }, []);
  return (
    <div>
      <h2 style={{ color: '#333', marginBottom: '20px' }}>ダッシュボード</h2>
      {currentUser && (
        <div style={{ 
          backgroundColor: 'white', 
          padding: '20px', 
          borderRadius: '8px',
          marginBottom: '20px'
        }}>
          <h3 style={{ 
            backgroundColor: '#ff6b35', 
            color: 'white', 
            padding: '10px',
            margin: '-20px -20px 20px -20px',
            borderRadius: '8px 8px 0 0'
          }}>
            会員情報
          </h3>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
            {currentUser.photoLink ? (
              <img 
                src={currentUser.photoLink?.photodatas || currentUser.photoLink || null} 
                alt="Profile" 
                style={{ 
                  width: '20%', 
                  height: '20%', 
                  // borderRadius: '50%', 
                  marginRight: '10px',
                  objectFit: 'cover'
                }} 
              />
            ) : (
              <div style={{ 
                width: '20%', 
                height: '20%', 
                // borderRadius: '50%', 
                backgroundColor: '#ddd',
                marginRight: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                写真なし
              </div>
            )}
            <div style={{paddingLeft:'15px'}}>
              <p><strong>名前:</strong> {currentUser.name || '未設定'}</p>
              <p><strong>ポイント:</strong> {currentUser.sendPoints}</p>
              {/* <p><strong>ユーザーID:</strong> {currentUser.userID}</p>
              <p><strong>ポイント:</strong> {currentUser.points}</p>
              <p><strong>送信ポイント:</strong> {currentUser.sendPoints}</p>
              <p><strong>誕生日:</strong> {currentUser.birthday || '未設定'}</p>
              <p><strong>職業:</strong> {currentUser.occupation?.occupaionName || '未設定'}</p>
              <p><strong>年収:</strong> {currentUser.annual_income?.annualIncome || '未設定'}</p> */}
              <p><strong>登録日:</strong> {currentUser.createdAt ? new Date(currentUser.createdAt).toLocaleDateString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit' }) : '未設定'}</p>
            </div>
          </div>
          {/* <button 
            onClick={onEditProfile}
            style={{
              backgroundColor: '#ff6b35',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            プロフィール編集
          </button> */}
        </div>
      )}
    </div>
  );
};

export default Dashboard; 